/** One row of the F48 action×tier cost matrix as the explainer surfaces render it. */
export interface CostRow {
  nameKey: 'creditsInfo.action.generate' | 'creditsInfo.action.expand' | 'creditsInfo.action.difficultyElevate' | 'creditsInfo.action.translate' | 'creditsInfo.action.illustrate';
  pro: boolean;
  standard: number;
  advanced: number;
  mastery: number;
}

/**
 * Illustrative cost rows for the F48 credits explainer (design/app/
 * 33-credits-info.html, `rCreditsInfo`) — the SINGLE client-side source
 * shared by `CreditsInfoModal` (`/settings/billing`) and
 * `CreditsExplainerPage` (`/pricing/credits`), so the two F48 surfaces can
 * never drift from each other.
 *
 * There is no live `billing.*` op that lists the action×tier cost matrix
 * for display (only per-action `enhancement.cost.estimate`-style ops exist,
 * see `apps/server/src/enhancement/ops.ts`), and the authoritative matrix
 * (`action_credit_costs`, seeded from `packages/db/src/seed/data.ts`
 * `SEED_ACTION_CREDIT_COSTS`) lives behind server-only packages
 * (`@xdocs/db`/`@xdocs/core`) that must not enter the client bundle — so
 * these rows/labels/numbers are hardcoded verbatim from the mockup
 * (mockup-33) rather than derived from the dev-seed formula. Keep in sync
 * by hand until a real `billing.costSchedule.list` op exists (see return
 * notes on the task that shipped `CreditsInfoModal`).
 */
export const COST_ROWS: readonly CostRow[] = [
  { nameKey: 'creditsInfo.action.generate', pro: false, standard: 32, advanced: 40, mastery: 52 },
  { nameKey: 'creditsInfo.action.expand', pro: true, standard: 18, advanced: 24, mastery: 30 },
  { nameKey: 'creditsInfo.action.difficultyElevate', pro: true, standard: 12, advanced: 18, mastery: 24 },
  { nameKey: 'creditsInfo.action.translate', pro: true, standard: 16, advanced: 22, mastery: 28 },
  { nameKey: 'creditsInfo.action.illustrate', pro: true, standard: 24, advanced: 30, mastery: 38 },
];
